module.exports = __webpack_public_path__ + "img/redBalloneHalf.e240a74e.png";